"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateTemplate = class CreateTemplate extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateTemplate');
    }
    objectTypes;
    async $$load_objectTypes() {
        return this.$fn.getEnumValuesFromSchema('ObjectTypes');
    }
    templateTypes;
    async $$load_templateTypes() {
        return this.$fn.getEnumValuesFromSchema('TemplateTypes');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'item', 'objectTypes', 'templateTypes', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "template",
                item: null,
                objectTypes: null,
                templateTypes: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Templates", "Create Template"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5774_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_5780_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async evh_1040167445267876_success_5779_getWhen($event) {
        return !!this.modalName;
    }
    async act_1040167445267876_request_5778_getActionArgs($event) {
        return {
            operation: "create_template",
            data: { ...this.item, content: '<div></div>' },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5774 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5774_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5773 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5774,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5773],
        });
        const act_2248226175642056_closeComponent_5776 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5775 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5776,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5775],
        });
        const act_1040167445267876_closeModal_5780 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_5780_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5779 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_5780,
            event: "success",
            when: this.evh_1040167445267876_success_5779_getWhen,
            displayName: "closeModal",
        });
        const act_1040167445267876_request_5778 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_5778_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_5779],
        });
        const evh_1040167445267876_submit_5777 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_5778,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5777],
        });
        const act_1419464017721962_closeModal_5782 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_5781 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_5782,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_5781],
        });
        return {
            act_7315092382398562_closeModal_5774,
            evh_7315092382398562_close_5773,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5776,
            evh_2248226175642056_close_5775,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_5780,
            evh_1040167445267876_success_5779,
            act_1040167445267876_request_5778,
            evh_1040167445267876_submit_5777,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_5782,
            evh_1419464017721962_clickPreventStop_5781,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_5778,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "sm",
    }),
    __metadata("design:type", String)
], CreateTemplate.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateTemplate.prototype, "onSize", null);
CreateTemplate = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateTemplate);
exports.default = CreateTemplate;
vue_property_decorator_1.Vue.component("CreateTemplate", CreateTemplate);
